// import { FAC_FEATURE_ID } from '@bingads-webui-campaign/recommendation-core';

const GOOGLE_FAC_FEATUREID = 209; // parseInt(FAC_FEATURE_ID.CALLOUTCARD_GOOGLE_IMPORT, 10);
const PINTEREST_FAC_FEATUREID = 210; // parseInt(FAC_FEATURE_ID.CALLOUTCARD_PINTEREST_IMPORT, 10);
const FACEBOOK_FAC_FEATUREID = 211; // parseInt(FAC_FEATURE_ID.CALLOUTCARD_FACEBOOK_IMPORT, 10);

export const RecommendationID = {
  ResumeScheduleId: 100,
  NeverUsedId: 200,
  ResumeImportId: 300,
  SmartNeverUsedId: 400,
  PinterestNeverUsedId: 500,
  FacebookAudienceSupportId: 600,
};

export const RecommendationPriority = {
  ResumeSchedulePriority: 0,
  NeverUsedPriority: 1,
  SmartNeverUsedPriority: 2,
  PinterestNeverUsedPriority: 3,
  FacebookAudienceSupportPriority: 4,
  ResumeImportPriority: 5,
};

export const RecommendationStatus = {
  Active: 'Active',
  Clicked: 'Clicked',
  Dismissed: 'Dismissed',
  Adopted: 'Adopted',
  Viewed: 'Viewed',
};

export const RecommendationIDPriorityMapping = {
  [RecommendationID.ResumeScheduleId]: RecommendationPriority.ResumeSchedulePriority,
  [RecommendationID.NeverUsedId]: RecommendationPriority.NeverUsedPriority,
  [RecommendationID.ResumeImportId]: RecommendationPriority.ResumeImportPriority,
  [RecommendationID.SmartNeverUsedId]: RecommendationPriority.SmartNeverUsedPriority,
  [RecommendationID.PinterestNeverUsedId]: RecommendationPriority.PinterestNeverUsedPriority,
  // eslint-disable-next-line max-len
  [RecommendationID.FacebookAudienceSupportId]: RecommendationPriority.FacebookAudienceSupportPriority,
};

export const RecommendationIDCouponIdMapping = {
  [RecommendationID.NeverUsedId]: GOOGLE_FAC_FEATUREID,
  [RecommendationID.SmartNeverUsedId]: GOOGLE_FAC_FEATUREID,
  [RecommendationID.PinterestNeverUsedId]: PINTEREST_FAC_FEATUREID,
  [RecommendationID.FacebookAudienceSupportId]: FACEBOOK_FAC_FEATUREID,
};

export const settings = {
  // delay after page load to show the callout card
  DisplayDelayInMilliSecs: 5000, //
  //
  GoogleImportRecommendationCoolDownPeriodInMilliSecs: 48 * 60 * 60 * 1000, // 48 hours
  UnsentActionCacheExpirationTimeInMilliSecs: 72 * 60 * 60 * 1000, // 72 hours
};

export const StorageKey = 'com.microsoft.ads.import-callout-card-storage';
